import { lazy, Suspense, useContext } from 'react'
import type { ReactNode } from 'react'
import CurveGateCard from '@/components/CurveGateCard'
import { WalletReadyContext } from '@/lib/walletContext'
import type { CurveWallet } from '@/hooks/useCurveWallet'

const CurveWalletGateReady = lazy(() => import('@/components/CurveWalletGateReady'))

type CurveWalletGateProps = {
  children: (wallet: CurveWallet) => ReactNode
  actionLabel: string
}

function CurveWalletGate({ children, actionLabel }: CurveWalletGateProps) {
  const ready = useContext(WalletReadyContext)

  const startingFallback = (
    <CurveGateCard
      title="Wallet is starting"
      body={`${actionLabel} will unlock once wallet connect is ready.`}
      actionLabel="Connect Wallet"
      disabled
    />
  )

  if (!ready) return startingFallback

  return (
    <Suspense fallback={startingFallback}>
      <CurveWalletGateReady actionLabel={actionLabel}>
        {children}
      </CurveWalletGateReady>
    </Suspense>
  )
}

export default CurveWalletGate
